import { render } from "./solicitudes.vue?vue&type=template&id=75ab9812"
import script from "./solicitudes.vue?vue&type=script&lang=js"
export * from "./solicitudes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__